<template>
	<div class="container__planejamentocronograma">
		<div
			:class="['container__planejamentocronograma__planejamento', { extend: extenderPlanejamento }]"
		>
			<Planejamento
				ref="ref__planejamento"
				:extender-planejamento="() => (extenderPlanejamento = !extenderPlanejamento)"
				:esta-expandido="extenderPlanejamento"
				:abrir-regras-de-otimizacao="abrirRegrasDeOtimizacao"
				:voltar-para-listagem-de-cronogramas="voltarParaCronogramas"
				:estratos-presentes-no-agrupamento="estratosQuePossuemPlantiosEmVisualizacaoPorAgrupamento"
				:estrato-em-visualizacao="estratoEmVisualizacao"
				:salvando-para-continuar-mais-tarde="salvandoParaContinuarMaisTarde"
				:salvando-ordens-de-servico="salvandoOrdensDeServico"
				@clicouEmSalvarParaContinuarMaisTarde="salvarParaContinuarMaisTarde"
				@clicouEmExcluirTodosOsPlanejamentos="excluirTodosOsPlanejamentosPossiveis"
				@clicouParaCriarOrdensDeServico="criarOrdensDeServico"
				@selecionouPlanejamento="mudarPlantioQueDeveEstarVisivel"
				@selecionouNovoRangeDeDataParaOS="atualizarDataDaOrdemDeServico"
				@excluiuPlanejamento="excluirPlanejamento"
			/>
		</div>

		<div :class="['container__planejamentocronograma__mapa', { extend: extenderPlanejamento }]">
			<GmapMap
				ref="ref__googlemaps"
				map-type-id="satellite"
				class="container__googlemaps__position"
				style="padding: 1rem"
				:center="{ lat: -20.462351187129975, lng: -53.6321620971719 }"
				:zoom="15"
				:options="{
					mapTypeControl: false,
					scaleControl: false,
					zoomControl: false,
					streetViewControl: false,
					fullscreenControl: false,
				}"
			>
				<template #visible>
					<div class="container__planejamentocronograma__mapa__filtros">
						<div class="container__planejamentocronograma__mapa__filtros__escolhidos">
							<Tag
								v-for="(filtro, index) in filtroTag"
								:key="index"
								:label="filtro.descricao"
								class-name="trv-primary"
								style="margin: 0.1rem"
							/>
						</div>
						<div class="container__planejamentocronograma__mapa__filtros__buttons">
							<FiltroPlanejamentoDeCronograma
								v-show="!planejamentoJaGerouOrdensDeServico"
								:filtros-salvos-no-banco="filtrosSalvos"
								@aplicaFiltros="realizarFiltro"
								@carregouFiltrosSalvosDoBanco="setarFiltros"
							/>
							<!-- <i class="fas fa-filter"></i> -->
							<MarkersDoMapa
								:alterar-exibicao-marker-de-talhao="() => (markers.talhao = !markers.talhao)"
								:alterar-exibicao-marker-de-plantio="() => (markers.plantio = !markers.plantio)"
								:alterar-exibicao-marker-de-ocorrencia="
									() => (markers.ocorrencia = !markers.ocorrencia)
								"
							/>
						</div>
					</div>
					<div class="container__planejamentocronograma__mapa__agrupamento">
						<div style="flex-grow: 1" />
						<RegrasDeAgrupamento
							ref="ref_regras_de_agrupamento"
							@regraAgrupamentoMudou="atualizarRegraDeAgrupamento"
						/>
					</div>
					<div
						v-show="carregandoPlantios"
						class="container__planejamentocronograma__mapa__loading"
					>
						<Loading />
					</div>
				</template>

				<MarkerGrupoDePlantios
					v-if="Object.keys(markerDoEstrato).length !== 0"
					ref="ref__marker__grupo__de__plantios"
					:marker-options="markerDoEstrato"
					:proximo-grupo="irParaOProximoGrupoDePlantios"
					:grupo-anterior="irParaOGrupoDePlantiosAnterior"
					@clicouEmEditarPlanejamento="abrirFormularioParaEdicaoDePlanejamento"
				/>

				<!-- Poligonos de Fazenda -->
				<PolygonShape
					v-for="(plantio, index) in plantios"
					:key="`fazenda-${index}`"
					:options="{
						fillColor: '#ffffff',
						strokeColor: '#ffffff',
						strokeOpacity: 1,
						fillOpacity: 0,
						strokeWeight: 2,
						zIndex: 10,
					}"
					:coordinates="plantio.geometry.coordinates"
					:type="plantio.geometry.type"
					:properties="plantio.properties"
				/>

				<!-- Plantios que foram agrupados -->
				<PolygonShape
					v-for="(plantio, index) in plantiosParaSeremExibidosNoAgrupamento"
					:key="`plantio-${index}`"
					:options="{
						fillColor: '#f6fa00',
						strokeColor: '#f6fa00',
						strokeOpacity: 1,
						fillOpacity: 0.6,
						strokeWeight: 2,
						zIndex: 15,
					}"
					:coordinates="plantio.geometry.coordinates"
					:type="plantio.geometry.type"
					:properties="plantio.properties"
				/>

				<!-- Poligonos de plantio para visualizacao dos grupos formados -->
				<PolygonShape
					v-for="(estrato, index) in plantiosDoEstratoEmVisualizacao"
					:key="`estrato-${index}`"
					:options="{
						fillColor: '#3ebd3e',
						strokeColor: '#3ebd3e',
						strokeOpacity: 1,
						fillOpacity: 0.6,
						strokeWeight: 2,
						zIndex: 20,
					}"
					:coordinates="estrato.geometry.coordinates"
					:type="estrato.geometry.type"
					:properties="estrato.properties"
				/>

				<!-- Poligonos para interacao -->
				<PolygonShape
					v-for="(plantio, index) in plantios"
					:key="`plantio-click-${index}`"
					:options="{
						fillColor: '#ffffff',
						strokeColor: '#ffffff',
						strokeOpacity: 0,
						fillOpacity: 0,
						strokeWeight: 0,
						zIndex: 30,
					}"
					:coordinates="plantio.geometry.coordinates"
					:type="plantio.geometry.type"
					:properties="plantio.properties"
					@click="setarNovaVisualizacao"
				/>

				<GmapCustomMarker
					v-for="markerTalhaoEPlantio in makersTalhaoEPlantio"
					:key="markerTalhaoEPlantio.key"
					:marker="markerTalhaoEPlantio.latlng"
				>
					<p style="color: white; font-size: 0.875rem; font-weight: 700">
						{{ markerTalhaoEPlantio.plantio }}
					</p>
				</GmapCustomMarker>

				<MarkerOcorrenciaComFoto
					v-for="ocorrenciaComImagem in ocorrenciasComImagem"
					:key="ocorrenciaComImagem.key"
					:marker-options="ocorrenciaComImagem"
					@ampliarFoto="ampliarFoto"
				/>
			</GmapMap>

			<!-- Foto da ocorrencia em tela cheia -->
			<div
				v-show="existeOcorrenciaParaExibirDetalhes"
				class="container__planejamentocronograma__foto__ocorrencia"
				@click="ocorrenciaDetalhes = {}"
			>
				<div class="container__planejamentocronograma__foto__ocorrencia__inner">
					<img
						:src="ocorrenciaDetalhes.urlImagem"
						class="container__planejamentocronograma__foto__ocorrencia__inner__imagem"
					/>
					<div class="container__planejamentocronograma__foto__ocorrencia__inner_detalhes">
						<p>{{ ocorrenciaDetalhes.executor }}</p>
						<p>{{ ocorrenciaDetalhes.observacoes }}</p>
					</div>
				</div>
			</div>

			<!-- Formulario para editar Executor e data da Ordem de Servico  -->
			<Modal
				v-show="editarPlanejamento"
				style="z-index: 60"
			>
				<div class="container__planejamentocronograma__edicao">
					<div class="container__planejamentocronograma__header">
						<div class="container__planejamentocronograma__header__titulo">
							<i class="fas fa-pencil-alt" />
							<p>Editar planejamento</p>
						</div>
						<p class="container__planejamentocronograma__header__subtitulo">
							Edite o planejamento alterando quem irá executar a ordem de serviço e a data de
							execução
						</p>
					</div>
					<div class="container__planejamentocronograma__body">
						<Dropdown
							v-model="planejamentoDeEstratoEmEdicao.executorId"
							label="Executor"
							:options="executoresDropdown"
						/>
						<DatePicker
							v-model="planejamentoDeEstratoEmEdicao.inicioOs"
							label="Data de Inicio"
						/>
						<DatePicker
							v-model="planejamentoDeEstratoEmEdicao.prazoOs"
							label="Prazo final"
						/>
					</div>
					<div class="container__planejamentocronograma__bottom">
						<Button
							label="Cancelar"
							outlined
							@click="fecharEdicaoDePlanejamento"
						/>
						<Button
							label="Concluir"
							@click="confirmarEdicao"
						/>
					</div>
				</div>
			</Modal>
		</div>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import * as turf from '@turf/turf'

import Button from '../../../../components/Button/Button'
import DatePicker from '../../../../components/DatePicker/DatePicker'
import Dropdown from '../../../../components/Dropdown/Dropdown'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import FiltroPlanejamentoDeCronograma from './FiltroPlanejamentoDeCronograma/FiltroPlanejamentoDeCronograma'
import MarkerGrupoDePlantios from './MarkerGrupoDePlantios/MarkerGrupoDePlantios'
import MarkersDoMapa from './MarkersDoMapa/MarkersDoMapa'
import Loading from '../../../../components/Loading/Loading'
import MarkerOcorrenciaComFoto from './MarkerOcorrenciaComFoto/MarkerOcorrenciaComFoto'
import Modal from '../../../../components/Modal/Modal'
import RegrasDeAgrupamento from './RegrasDeAgrupamento/RegrasDeAgrupamento'
import Planejamento from './Planejamento/Planejamento'
import PolygonShape from '../../../../components/Map/PolygonShape'
import Tag from '../../../../components/Tag/Tag'

import otimizacaoDeCronogramaDeOrdemDeServicoMixins from '../../../../mixins/OtimizacaoDeCronogramaDeOrdemDeServicoMixins'

import { buscarPoligonosParaPlenajementoDeCronogramaDeOrdemDeServico } from '../../../../services/requests/Gis'
import { recuperarOcorrenciasParaCronogramaDeOrdemDeServico } from '../../../../services/requests/OcorrenciaRequests'
import { getDropdownExecutores } from '../../../../services/requests/ExecutorRequests'
import {
	atualizarFiltroUsadoNoCronograma,
	cadastrarOrdensDeServico,
	excluirCronograma,
} from '../../../../services/requests/CronogramaDeOrdemDeServicoRequests'
import {
	salvarPlanejamentosDeCronogramas,
	buscarPlanejamentosParaGantt,
} from '../../../../services/requests/CronogramaDeOrdemDeServicoPlanejamentoRequests'

import { mapMutations } from 'vuex'

export default {
	components: {
		Button,
		DatePicker,
		Dropdown,
		GmapCustomMarker,
		FiltroPlanejamentoDeCronograma,
		MarkerGrupoDePlantios,
		MarkersDoMapa,
		MarkerOcorrenciaComFoto,
		Loading,
		Modal,
		RegrasDeAgrupamento,
		Planejamento,
		PolygonShape,
		Tag,
	},
	data() {
		return {
			filtros: {
				dataDaUltimaMedicao: {},
				dataDePlantio: {},
				fazendasSelecionadas: [],
				materiaisGeneticosSelecionados: [],
				tiposDeOrdensDeServicosSelecionados: [],
			},
			regrasDeAgrupamento: [],
			plantiosAgrupados: [],
			carregandoPlantios: false,
			plantios: [],
			estratos: [],
			extenderPlanejamento: false,
			markers: {
				plantio: false,
				talhao: false,
				ocorrencia: false,
			},
			todosOsExecutores: [],
			ocorrencias: [],
			ocorrenciaDetalhes: {},
			editarPlanejamento: false,
			planejamentoDeEstratoEmEdicao: {
				estratoFlorestalId: '',
				executorId: '',
				inicioOs: '',
				prazoOs: '',
			},
			forcarNovoEstratoEmVisualizacao: 0,
			salvandoParaContinuarMaisTarde: false,
			salvandoOrdensDeServico: false,
		}
	},
	computed: {
		existeFiltroSelecionado() {
			const existeFiltroDeFazenda = this.filtros.fazendasSelecionadas.length > 0
			const existeFiltroDeMaterialGenetico = this.filtros.materiaisGeneticosSelecionados.length > 0
			const existeFiltroDeUltimoTipoDeOrdemDeServico =
				this.filtros.tiposDeOrdensDeServicosSelecionados.length > 0
			const existeFiltroDeDataDePlantio =
				this.filtros.dataDePlantio?.start && this.filtros.dataDePlantio?.end
			const existeFiltroDeDataDaUltimaMedicao =
				this.filtros.dataDaUltimaMedicao?.start && this.filtros.dataDaUltimaMedicao?.end

			return (
				existeFiltroDeFazenda ||
				existeFiltroDeMaterialGenetico ||
				existeFiltroDeUltimoTipoDeOrdemDeServico ||
				existeFiltroDeDataDePlantio ||
				existeFiltroDeDataDaUltimaMedicao
			)
		},
		makersTalhaoEPlantio() {
			if (
				this.plantioEmVisualizacao.plantiosDoGrupo &&
				(this.markers.talhao || this.markers.plantio)
			) {
				return this.plantioEmVisualizacao.plantiosDoGrupo.map((plantio) => {
					let label = ''
					if (this.markers.talhao && this.markers.plantio)
						label = `${plantio.properties.talhao} - ${plantio.properties.plantio}`
					else if (this.markers.plantio) label = plantio.properties.plantio
					else if (this.markers.talhao) label = plantio.properties.talhao

					const centroidFeature = turf.centroid(plantio)
					const latitude = centroidFeature.geometry.coordinates[1]
					const longitude = centroidFeature.geometry.coordinates[0]
					return {
						key: uuidv4(),
						plantio: label,
						latlng: { lat: latitude, lng: longitude },
					}
				})
			}

			return []
		},
		filtroTag() {
			const filtros = []

			if (this.filtros.dataDaUltimaMedicao?.start && this.filtros.dataDaUltimaMedicao?.end) {
				filtros.push({
					tipo: 'dataDaUltimaMedicao',
					descricao: `Data da última medição: ${this.filtros.dataDaUltimaMedicao.start.toLocaleDateString()} - ${this.filtros.dataDaUltimaMedicao.end.toLocaleDateString()}`,
				})
			}

			if (this.filtros.dataDePlantio?.start && this.filtros.dataDePlantio?.end) {
				filtros.push({
					tipo: 'dataDePlantio',
					descricao: `Data do plantio: ${this.filtros.dataDePlantio.start.toLocaleDateString()} - ${this.filtros.dataDePlantio.end.toLocaleDateString()}`,
				})
			}

			if (this.filtros.fazendasSelecionadas) {
				filtros.push(
					...this.filtros.fazendasSelecionadas.map((fazenda) => {
						return {
							tipo: 'fazendasSelecionadas',
							id: fazenda.id,
							descricao: fazenda[this.$t('name')],
						}
					}),
				)
			}

			if (this.filtros.materiaisGeneticosSelecionados) {
				filtros.push(
					...this.filtros.materiaisGeneticosSelecionados.map((materialGenetico) => {
						return {
							tipo: 'materiaisGeneticosSelecionados',
							id: materialGenetico.id,
							descricao: materialGenetico['Código'],
						}
					}),
				)
			}

			if (this.filtros.tiposDeOrdensDeServicosSelecionados) {
				filtros.push(
					...this.filtros.tiposDeOrdensDeServicosSelecionados.map((tipoDeOrdemDeServico) => {
						return {
							tipo: 'tipoDeOrdemDeServico',
							codigo: tipoDeOrdemDeServico.codigo,
							descricao: `${tipoDeOrdemDeServico.codigo} - ${tipoDeOrdemDeServico.descricao}`,
						}
					}),
				)
			}

			return filtros
		},
		plantioEmVisualizacao() {
			const plantioEmVisulizacao = this.plantiosAgrupados.find(
				(plantioAgrupado) => plantioAgrupado.estaEmVisualizacao,
			)

			return plantioEmVisulizacao ? plantioEmVisulizacao : []
		},
		ocorrenciasComImagem() {
			if (this.plantioEmVisualizacao.plantiosDoGrupo && this.markers.ocorrencia) {
				return this.ocorrencias
					.filter((ocorrencia) => {
						const ocorrenciaPossuiImagem = ocorrencia.urlImagem !== ''

						const coordenadaDaOcorrencia = turf.point([
							ocorrencia.coordenadaX,
							ocorrencia.coordenadaY,
						])
						const ocorrenciaEstaEntreOsPlantiosEmVisualizacao = turf.inside(
							coordenadaDaOcorrencia,
							this.uniaoDosPoligonosEmVisualizacao,
						)

						return ocorrenciaPossuiImagem && ocorrenciaEstaEntreOsPlantiosEmVisualizacao
					})
					.map((ocorrencia) => {
						return {
							key: uuidv4(),
							latlng: { lat: ocorrencia.coordenadaY, lng: ocorrencia.coordenadaX },
							urlImagem: ocorrencia.urlImagem,
							executor: ocorrencia.executor,
							observacoes: ocorrencia.observacoes,
							parcela: ocorrencia.parcela,
						}
					})
			}
			return []
		},
		uniaoDosPoligonosEmVisualizacao() {
			return this.plantioEmVisualizacao.plantiosDoGrupo.reduce((plantioAcumulador, plantio) =>
				turf.union(plantioAcumulador, plantio),
			)
		},
		existeOcorrenciaParaExibirDetalhes() {
			return Object.keys(this.ocorrenciaDetalhes).length !== 0
		},
		possuiConfiguracaoDeRegrasDeOtimizacaoPorDatas() {
			return this.regrasDeOtimizacao.tipoDeOrdemDeServico.length > 0
		},
		todosOsPlantiosDoEstrato() {
			var plantiosEncontrados = []
			this.estratos
				.map((m) => m.plantiosDoGrupo)
				.forEach((plantios) => {
					plantiosEncontrados.push(...plantios)
				})
			return plantiosEncontrados
		},
		plantiosDoEstratoEmVisualizacao() {
			if (this.estratoEmVisualizacao) return this.estratoEmVisualizacao.plantiosDoGrupo
			return []
		},
		markerDoEstrato() {
			if (!this.estratoEmVisualizacao) return {}

			return {
				estrato: this.estratoEmVisualizacao.estrato,
				numeroDePlantios: this.estratoEmVisualizacao.plantiosDoGrupo.length,
				area: this.areaDosPlantiosEmVisualizacao.toFixed(2),
				centroid: { lat: this.centroidDoEstrato[1], long: this.centroidDoEstrato[0] },
			}
		},
		areaDosPlantiosEmVisualizacao() {
			return this.estratoEmVisualizacao.plantiosDoGrupo
				.filter((plantio) => plantio.properties.area)
				.map((plantio) => plantio.properties.area)
				.reduce((somaArea, area) => somaArea + area, 0)
		},
		estratoEmVisualizacao() {
			this.forcarNovoEstratoEmVisualizacao
			return this.estratos.find((estrato) => estrato.estaEmVisualizacao)
		},
		poligonoDoEstrato() {
			return this.estratoEmVisualizacao.plantiosDoGrupo.reduce((plantioAcumulador, plantio) =>
				turf.union(plantioAcumulador, plantio),
			)
		},
		centroidDoEstrato() {
			return turf.centroid(this.poligonoDoEstrato).geometry.coordinates
		},
		plantiosParaSeremExibidosNoAgrupamento() {
			return this.plantiosAgrupadosEmVisualizacao.plantiosDoGrupo
		},
		plantiosAgrupadosEmVisualizacao() {
			return this.plantiosAgrupados.find((plantios) => plantios.estaEmVisualizacao) !== undefined
				? this.plantiosAgrupados.find((plantios) => plantios.estaEmVisualizacao)
				: []
		},
		possuiRegraDeAgrupamento() {
			return this.regrasDeAgrupamento.some((regra) => regra.prioridade)
		},
		estratosQuePossuemPlantiosEmVisualizacaoPorAgrupamento() {
			if (this.plantiosParaSeremExibidosNoAgrupamento !== undefined)
				return this.plantiosParaSeremExibidosNoAgrupamento.map(
					(plantio) => plantio.properties.estratoFlorestalId,
				)
			return []
		},
		idDoEstratoEmVisualizacao() {
			if (this.estratoEmVisualizacao !== undefined)
				return this.estratoEmVisualizacao.estratoFlorestalId
			return ''
		},
		executoresDropdown() {
			return this.todosOsExecutores
				.map((executor) => {
					return { label: executor[this.$t('name')], value: executor.id }
				})
				.sort((executor1, executor2) => executor1.label.localeCompare(executor2.label))
		},
		podeExcluirPlanejamento() {
			if (this.estratoEmVisualizacao !== undefined)
				return this.estratoEmVisualizacao.podeExcluirPlanejamento
			return false
		},
		planejamentosDeEstratosQuePodemSerExcluidos() {
			return this.estratos.filter((estrato) => estrato.podeExcluirPlanejamento)
		},
		possuiEstratosPlanejados() {
			return this.estratos.length > 0
		},
	},
	methods: {
		...mapMutations('moduleMessages', ['mutationShowMessage']),

		atualizarRegraDeAgrupamento(regrasDeAgrupamento) {
			this.regrasDeAgrupamento = regrasDeAgrupamento

			if (this.possuiRegraDeAgrupamento) this.aplicarRegraDeAgrupamento()
			else this.plantiosAgrupados = []
		},
		aplicarRegraDeAgrupamento() {
			// Preserva os grupos que foram planejados para agrupar apenas os que ainda nao foram planejado
			this.plantiosAgrupados = []

			// Faz o grupo de plantios sem plano de colheita
			let preAgrupamento = this.realizarGrupoDePlantios()

			const possuiRegraDeProximidade = this.regrasDeAgrupamento.some(
				(regra) => regra.prioridade != null && regra.value == 'PROXIMIDADE',
			)

			if (possuiRegraDeProximidade)
				preAgrupamento = this.realizarAgrupamentoPorProximidade(preAgrupamento)

			for (let grupoAtual in preAgrupamento) {
				this.plantiosAgrupados.push({
					plantiosDoGrupo: preAgrupamento[grupoAtual],
					planoDeColheita: false,
					estaEmVisualizacao: false,
				})
			}

			if (this.plantiosAgrupados.length > 0) {
				// Ids dos plantios que estao em visualizacao
				const idsDosPlantiosEmVisualizacao = this.estratoEmVisualizacao.plantiosDoGrupo.map(
					(plantio) => plantio.properties.plantioId,
				)

				// Indice dos grupos que devem estar sendo visualizados
				const indicesDosGruposQueDevemEstarEmVisualizacao = []

				// Busca em quais grupos os plantios do estrato que está em visualizacao estão presentes
				this.plantiosAgrupados
					.map((plantios) =>
						plantios.plantiosDoGrupo.map((plantio) => plantio.properties.plantioId),
					)
					.forEach((listaDeIds, indice) => {
						const existePlantioDoEstratoEmVisualizacaoQuePertenceAEsteGrupo = listaDeIds.some(
							(id) => idsDosPlantiosEmVisualizacao.includes(id),
						)

						if (existePlantioDoEstratoEmVisualizacaoQuePertenceAEsteGrupo)
							indicesDosGruposQueDevemEstarEmVisualizacao.push(indice)
					})

				indicesDosGruposQueDevemEstarEmVisualizacao.forEach((indiceEmVisualizacao) => {
					this.plantiosAgrupados[indiceEmVisualizacao].estaEmVisualizacao = true
				})

				this.aplicarZoomNosPlantiosEAgrupamento()
			}
		},
		realizarGrupoDePlantios() {
			const plantiosParaAgrupar = this.plantios

			const regrasValidas = this.regrasDeAgrupamento
				.filter((regra) => regra.prioridade !== null)
				.sort((regra1, regra2) => regra1.prioridade - regra2.prioridade)

			return Object.groupBy(plantiosParaAgrupar, function (plantio) {
				let valorChaveParaOGrupo = {
					fazendaId: plantio.properties.fazendaId,
				}

				regrasValidas.forEach((agrupamento) => {
					switch (agrupamento.value) {
						case 'DATADAULTIMAMEDICAO':
						case 'DATADOPLANTIO': {
							var dataReferencia = new Date(plantio.properties[agrupamento.nomePropriedade])
							valorChaveParaOGrupo.dataReferencia = new Date(
								0,
								dataReferencia.getMonth(),
								dataReferencia.getDate(),
							)
							break
						}
						case 'MATERIALGENETICO': {
							valorChaveParaOGrupo[agrupamento.value] =
								plantio.properties[agrupamento.nomePropriedade]
							break
						}
						case 'ANIVERSARIODOPLANTIO': {
							const milisegundosNoAno = 31536000000
							const idadeEmAnos = Math.floor(
								Math.abs(
									new Date().getTime() - new Date(plantio.properties.dataDoPlantio).getTime(),
								) / milisegundosNoAno,
							)

							valorChaveParaOGrupo.idadeEmAnos = idadeEmAnos
							break
						}
					}
				})
				return JSON.stringify(valorChaveParaOGrupo)
			})
		},
		realizarAgrupamentoPorProximidade(plantiosAgrupados) {
			const agrupamentoConsiderandoProximidade = {}

			for (let plantioAgrupadoChave in plantiosAgrupados) {
				const coordenadasCentroid = []

				plantiosAgrupados[plantioAgrupadoChave].forEach((plantio) => {
					const bbox = plantio.bbox
					const distanciaEntreOsPontosDaGridEmKM = 0.1
					const coordenadasBbox = turf.pointGrid(bbox, distanciaEntreOsPontosDaGridEmKM)
					const coordenadasDentroDoPlantio = coordenadasBbox.features.filter((coordenada) =>
						turf.inside(coordenada, plantio),
					)

					coordenadasDentroDoPlantio.forEach((coordenada) => {
						coordenada.properties.plantioId = plantio.properties.plantioId
						coordenadasCentroid.push(coordenada)
					})
				})

				const featureCollectionCentroids = {
					type: 'FeatureCollection',
					features: coordenadasCentroid,
				}
				const distanciaEntreOsPlantiosEmKM = 0.5
				const clusters = turf.clustersDbscan(
					featureCollectionCentroids,
					distanciaEntreOsPlantiosEmKM,
					{ units: 'kilometers' },
				)

				const clustersAgrupados = Object.groupBy(
					clusters.features,
					(cluster) => cluster.properties.cluster,
				)
				for (let clusterIndice in clustersAgrupados) {
					let chaveNova = ''
					let chaveDoCluster = { cluster: clusterIndice }

					if (plantioAgrupadoChave == '') chaveNova = JSON.stringify(chaveDoCluster)
					else {
						const chaveAgrupada = JSON.parse(plantioAgrupadoChave)
						const chaveNovaObjeto = Object.assign(chaveAgrupada, chaveDoCluster)
						chaveNova = JSON.stringify(chaveNovaObjeto)
					}

					const idsDosPlantiosNoCluster = clustersAgrupados[clusterIndice].map(
						(m) => m.properties.plantioId,
					)
					const plantiosNoClusterAtual = plantiosAgrupados[plantioAgrupadoChave].filter((plantio) =>
						idsDosPlantiosNoCluster.includes(plantio.properties.plantioId),
					)

					agrupamentoConsiderandoProximidade[chaveNova] = plantiosNoClusterAtual
				}
			}

			return agrupamentoConsiderandoProximidade
		},
		setarFiltros(filtro) {
			this.filtros = filtro
		},
		realizarFiltro(filtro) {
			var refazerPlanejamento = true
			if (this.estratos.length > 0)
				refazerPlanejamento = confirm(
					'Ao realizar o filtro, o planejamento atual terá que ser refeito, deseja prosseguir?',
				)

			this.setarFiltros(filtro)

			if (this.existeFiltroSelecionado && refazerPlanejamento) {
				var filtroDosPlantios = this.recuperarRequisicaoParaFiltrarPlantios()
				this.carregandoPlantios = true
				buscarPoligonosParaPlenajementoDeCronogramaDeOrdemDeServico(filtroDosPlantios).then(
					(response) => {
						this.carregandoPlantios = false

						this.plantios = []
						this.estratos = []

						if (this.planosDeColheita) this.estruturarEstratosPreCortes(response.data.features)

						this.plantios.push(...response.data.features)

						if (this.plantios.length > 0) {
							this.setarEstratosPrePlanejados()
							if (this.regrasDeOtimizacao.tipoDeOrdemDeServico.length > 0)
								this.otimizarOrdemDeServico()
							this.setarZoomDoMapa(this.todosOsPlantiosDoEstrato)
							this.plotarTabelaDePlanejamento()
						}
					},
				)
			}
		},
		estruturarEstratosPreCortes(plantios) {
			const idsPlantiosParaColheita = this.planosDeColheita.map(
				(planoDeColheita) => planoDeColheita.id,
			)
			const plantiosPlanoDeColheita = plantios.filter((plantio) =>
				idsPlantiosParaColheita.includes(plantio.properties.plantioId),
			)

			const plantiosAgrupadosPorDataDeColheita = Object.groupBy(
				plantiosPlanoDeColheita,
				(plantio) => {
					var dataColheita = this.planosDeColheita.find(
						(planoDeColheita) => planoDeColheita.id === plantio.properties.plantioId,
					).dataPlanoDeColheita

					return dataColheita
				},
			)

			let codigoPreCorte = 1
			for (let grupoAtual in plantiosAgrupadosPorDataDeColheita) {
				const plantios = plantiosAgrupadosPorDataDeColheita[grupoAtual]

				const idsDeParcelasDoEstrato = plantios.map((plantio) => plantio.properties.parcelas).flat()

				const quantidadeDeParcelas = idsDeParcelasDoEstrato.length

				this.estratos.push({
					planejamentoId: uuidv4(),
					estrato: `Pré-Corte ${codigoPreCorte}`,
					estratoFlorestalId: uuidv4(),
					plantiosDoGrupo: plantios,
					tipoDeOrdemDeServicoPlanejada: '003',
					planoDeColheita: true,
					estaEmVisualizacao: false,
					quantidadeDeParcelas: quantidadeDeParcelas,
					idsDeParcelasDoEstrato: idsDeParcelasDoEstrato,
					podeExcluirPlanejamento: true,
					dataReferencia: new Date(grupoAtual),
					inicioOs: new Date(this.dataDeInicio).getTime(),
					prazoOs: new Date(this.dataDeFinalizacao).getTime(),
				})

				codigoPreCorte++
			}
		},
		setarEstratosPrePlanejados() {
			const idsPlantiosPreCorte = this.planosDeColheita
				? this.planosDeColheita.map((planoDeColheita) => planoDeColheita.id)
				: []
			const plantiosQueNaoSaoPreCorte = this.plantios.filter(
				(plantio) => !idsPlantiosPreCorte.includes(plantio.properties.plantioId),
			)

			const plantiosPorEstrato = Object.groupBy(plantiosQueNaoSaoPreCorte, function (plantio) {
				return plantio.properties.estratoFlorestalId
			})

			for (let grupoAtual in plantiosPorEstrato) {
				const plantios = plantiosPorEstrato[grupoAtual]

				const idsDeParcelasDoEstrato = plantios.map((plantio) => plantio.properties.parcelas).flat()

				let quantidadeDeParcelas = idsDeParcelasDoEstrato.length

				let osPlanejada

				if (quantidadeDeParcelas > 0) {
					osPlanejada = '002' // OS de inventário contínuo
				} else {
					osPlanejada = '001' // OS de instalação
					quantidadeDeParcelas =
						this.estimarQuantidadeDeParcelasDeAcordoComAAreaDosPlantiosDoEstrato(
							plantiosPorEstrato[grupoAtual],
						)
				}

				const dataDeReferencia = this.recuperarDataDeReferenciaCasoPossuaRegraDeOtimizacao(
					osPlanejada,
					plantios,
				)

				this.estratos.push({
					planejamentoId: uuidv4(),
					estrato: plantios[0].properties.estratoFlorestal,
					estratoFlorestalId: grupoAtual,
					plantiosDoGrupo: plantios,
					tipoDeOrdemDeServicoPlanejada: osPlanejada,
					planoDeColheita: false,
					estaEmVisualizacao: false,
					quantidadeDeParcelas: quantidadeDeParcelas,
					idsDeParcelasDoEstrato: idsDeParcelasDoEstrato,
					podeExcluirPlanejamento: true,
					dataReferencia: dataDeReferencia
						? new Date(dataDeReferencia)
						: new Date(this.dataDeInicio),
					inicioOs: new Date(this.dataDeInicio).getTime(),
					prazoOs: new Date(this.dataDeFinalizacao).getTime(),
				})
			}

			if (this.estratos.length > 0) this.estratos[0].estaEmVisualizacao = true
		},
		estimarQuantidadeDeParcelasDeAcordoComAAreaDosPlantiosDoEstrato(plantiosDoEstrato) {
			const totalDeArea = this.calcularSomaDasAreasDosPlantios(plantiosDoEstrato)
			const quantidadeDeParcelasEstimadas = Math.ceil(totalDeArea / 10)
			return quantidadeDeParcelasEstimadas
		},
		calcularSomaDasAreasDosPlantios(plantios) {
			const valorInicial = 0

			return plantios
				.map((plantio) => plantio.properties.area)
				.reduce((acumulador, valorAtual) => acumulador + valorAtual, valorInicial)
		},
		recuperarDataDeReferenciaCasoPossuaRegraDeOtimizacao(osPlanejada, plantios) {
			const regra = this.regrasDeOtimizacao.tipoDeOrdemDeServico.find(
				(regra) => regra.tipoDeServico === osPlanejada,
			)

			if (!regra) return undefined

			return regra.dataReferencia === 'DATADOPLANTIO'
				? plantios[0].properties.dataDoPlantioMedia
				: plantios[0].properties.dataDaUltimaMedicao
		},
		setarZoomDoMapa(poligonos) {
			const featureCollection = turf.featureCollection(poligonos)
			const bbox = turf.bbox(featureCollection)

			this.$refs.ref__googlemaps.$mapPromise.then((map) => {
				setTimeout(function () {
					const coords = ['west', 'south', 'east', 'north']
					const bounds = Object.fromEntries(
						bbox.map((m, i) => {
							return [coords[i], m]
						}),
					)

					map.fitBounds(bounds, 0)
				}, 500)
			})
		},
		recuperarRequisicaoParaFiltrarPlantios() {
			return {
				fazendasIds: this.filtros.fazendasSelecionadas.map((fazenda) => fazenda.id),
				materiaisGeneticosIds: this.filtros.materiaisGeneticosSelecionados.map(
					(materialGenetico) => materialGenetico.id,
				),
				tipoDaUltimaOrdemDeServico: this.filtros.tiposDeOrdensDeServicosSelecionados.map(
					(tipoDeOrdemDeServico) => tipoDeOrdemDeServico.codigo,
				),
				plantiosParaPlanoDeColheita: this.planosDeColheita
					? this.planosDeColheita.map((planoDeColheita) => planoDeColheita.id)
					: [],
				dataDePlantioInicial: this.filtros.dataDePlantio?.start,
				dataDePlantioFinal: this.filtros.dataDePlantio?.end,
				inicioDataDeMedicao: this.filtros.dataDaUltimaMedicao?.start,
				finalDataDeMedicao: this.filtros.dataDaUltimaMedicao?.end,
				inicioDoCronograma: this.dataDeInicio,
				fimDoCronograma: this.dataDeFinalizacao,
				regrasDeOtimizacao: this.regrasDeOtimizacao.tipoDeOrdemDeServico.map((regra) => {
					return {
						tipoDeOrdemDeServico: regra.tipoDeServico,
						numeroDeMeses: regra.quantidadeDeMeses,
						tipoDePrazo: regra.tipoDePrazo,
						opcaoDeCriterio: regra.dataReferencia,
					}
				}),
			}
		},
		irParaOGrupoDePlantiosAnterior() {
			const indiceDoGrupoAnterior = this.estratos.map((m) => m.estaEmVisualizacao).indexOf(true) - 1
			const indiceDoNovoGrupoEmVisualizacao =
				indiceDoGrupoAnterior >= 0 ? indiceDoGrupoAnterior : this.estratos.length - 1

			this.$refs.ref__marker__grupo__de__plantios.ordemDeServicoSelecionada =
				this.estratos[indiceDoNovoGrupoEmVisualizacao].tipoDeOrdemDeServicoPlanejada
			this.mudarPlantioQueDeveEstarVisivel(
				this.estratos[indiceDoNovoGrupoEmVisualizacao].planejamentoId,
			)
		},
		irParaOProximoGrupoDePlantios() {
			const indiceDoProximoGrupoDePlantios =
				this.estratos.map((m) => m.estaEmVisualizacao).indexOf(true) + 1
			const posicaoDoUltimoGrupo = this.estratos.length - 1

			const indiceDoNovoGrupoEmVisualizacao =
				indiceDoProximoGrupoDePlantios <= posicaoDoUltimoGrupo ? indiceDoProximoGrupoDePlantios : 0

			this.$refs.ref__marker__grupo__de__plantios.ordemDeServicoSelecionada =
				this.estratos[indiceDoNovoGrupoEmVisualizacao].tipoDeOrdemDeServicoPlanejada
			this.mudarPlantioQueDeveEstarVisivel(
				this.estratos[indiceDoNovoGrupoEmVisualizacao].planejamentoId,
			)
		},
		ampliarFoto(ocorrenciaDetalhes) {
			this.ocorrenciaDetalhes = ocorrenciaDetalhes
		},
		excluirPlanejamento(idPlanejamento) {
			this.irParaOProximoGrupoDePlantios()

			const indiceDoEstratoExcluido = this.estratos
				.map((estrato) => estrato.planejamentoId)
				.indexOf(idPlanejamento)

			const [estratoRemovido] = this.estratos.splice(indiceDoEstratoExcluido, 1)

			if (estratoRemovido) {
				this.removerPlantios(estratoRemovido.plantiosDoGrupo)
				this.removerPlanejamentosDoExecutor(estratoRemovido.planejamentoId)
			}

			this.plotarTabelaDePlanejamento()
		},
		excluirTodosOsPlanejamentosPossiveis() {
			this.planejamentosDeEstratosQuePodemSerExcluidos.forEach((estratoExcluido) => {
				const indiceDoEstratoExcluido = this.estratos
					.map((estrato) => estrato.estratoFlorestalId)
					.indexOf(estratoExcluido.estratoFlorestalId)

				const [estratoRemovido] = this.estratos.splice(indiceDoEstratoExcluido, 1)

				if (estratoRemovido) {
					this.removerPlantios(estratoRemovido.plantiosDoGrupo)
					this.removerPlanejamentosDoExecutor(estratoRemovido.planejamentoId)
				}
			})

			if (this.estratos.length !== 0) this.irParaOProximoGrupoDePlantios()

			this.plotarTabelaDePlanejamento()
		},
		removerPlantios(plantios) {
			var idsDePlantiosParaRemover = plantios.map((plantio) => plantio.properties.plantioId)

			this.plantios = this.plantios.filter(
				(plantio) => !idsDePlantiosParaRemover.includes(plantio.properties.plantioId),
			)
		},
		removerPlanejamentosDoExecutor(planejamentoId) {
			var executorDoPlanejamentoExcluido = this.executores.find((executor) =>
				executor.planejamentosDoExecutor.some(
					(planejamento) => planejamento.planejamentoId === planejamentoId,
				),
			)

			if (executorDoPlanejamentoExcluido) {
				const planejamentosDoExecutor = executorDoPlanejamentoExcluido.planejamentosDoExecutor

				const indiceDoPlanejamentoExcluido = planejamentosDoExecutor
					.map((planejamento) => planejamento.planejamentoId)
					.indexOf(planejamentoId)

				const [planejamentoRemovido] = planejamentosDoExecutor.splice(
					indiceDoPlanejamentoExcluido,
					1,
				)

				const indiceInicioOS = executorDoPlanejamentoExcluido.datasEmServico
					.map((dataEmServico) => dataEmServico.getTime())
					.indexOf(planejamentoRemovido.inicioDaOS)

				executorDoPlanejamentoExcluido.datasEmServico.splice(indiceInicioOS, 1)

				const indiceFinalOS = executorDoPlanejamentoExcluido.datasEmServico
					.map((dataEmServico) => dataEmServico.getTime())
					.indexOf(planejamentoRemovido.prazoOS)

				executorDoPlanejamentoExcluido.datasEmServico.splice(indiceFinalOS, 1)

				executorDoPlanejamentoExcluido.quantidadeDeParcelasJaAlocadas -=
					planejamentoRemovido.quatidadeDeParcelas
			}
		},
		atualizarDataDaOrdemDeServico(idPlanejamento, novoRange) {
			const estrato = this.estratos.find((estrato) => estrato.planejamentoId === idPlanejamento)
			if (novoRange.start) estrato.inicioOs = novoRange.start
			if (novoRange.end) estrato.prazoOs = novoRange.end
		},
		plotarTabelaDePlanejamento() {
			this.$refs.ref__planejamento.planejamentos = this.estratos
		},
		mudarPlantioQueDeveEstarVisivel(idDoPlanejamento) {
			this.estratos.forEach((estrato) => {
				estrato.estaEmVisualizacao = false

				if (estrato.planejamentoId === idDoPlanejamento) {
					estrato.estaEmVisualizacao = true
				}
			})

			this.forcarNovoEstratoEmVisualizacao++

			if (this.possuiRegraDeAgrupamento) this.aplicarRegraDeAgrupamento()

			this.aplicarZoomNosPlantiosEAgrupamento()
		},
		aplicarZoomNosPlantiosEAgrupamento() {
			const plantiosParaZoom = []

			plantiosParaZoom.push(...this.plantiosDoEstratoEmVisualizacao)

			if (this.plantiosParaSeremExibidosNoAgrupamento != undefined)
				plantiosParaZoom.push(...this.plantiosParaSeremExibidosNoAgrupamento)

			this.setarZoomDoMapa(plantiosParaZoom)
		},
		abrirRegrasDeOtimizacao() {
			this.$emit('clicouEmEditarRegraDeOtimizacao')
		},
		voltarParaCronogramas() {
			this.$emit('clicouEmVoltar')
		},
		async salvarParaContinuarMaisTarde() {
			this.salvandoParaContinuarMaisTarde = true
			await this.atualizarFiltrosQueForamRealizados()
			await this.atualizarPlanejamentos()
			this.salvandoParaContinuarMaisTarde = false
			this.mutationShowMessage({
				messageTitle: this.$t('sucesso'),
				messageText: this.$t('planejamentoSalvo'),
				messageIcon: 'far fa-check-circle',
				messageType: 'success',
			})
			this.voltarParaCronogramas()
		},
		async atualizarFiltrosQueForamRealizados() {
			const filtrosDoCronograma = this.criarObjetoParaAtualizarConfiguracaoDeFiltrosDoCronograma()
			await atualizarFiltroUsadoNoCronograma(this.cronogramaId, filtrosDoCronograma)
		},
		async atualizarPlanejamentos() {
			const planejamentos = this.criarObjetoQueRepresentaOsPlanejamentosDoCronograma()
			await salvarPlanejamentosDeCronogramas(planejamentos)
		},
		criarObjetoParaAtualizarConfiguracaoDeFiltrosDoCronograma() {
			return {
				fazendas: this.filtros.fazendasSelecionadas.map((fazenda) => fazenda.id),
				materiaisGeneticos: this.filtros.materiaisGeneticosSelecionados.map(
					(materialGenetico) => materialGenetico.id,
				),
				tiposDeOrdemDeServico: this.filtros.tiposDeOrdensDeServicosSelecionados.map(
					(tipoDeOrdem) => tipoDeOrdem.codigo,
				),
				dataDeUltimaMedicaoInicial: this.filtros.dataDaUltimaMedicao.start,
				dataDeUltimaMedicaoFinal: this.filtros.dataDaUltimaMedicao.end,
				dataDePlantioInicial: this.filtros.dataDePlantio.start,
				dataDePlantioFinal: this.filtros.dataDePlantio.end,
				configuracoesDeGrupoDePlantio: this.regrasDeAgrupamento
					.filter((regra) => regra.prioridade)
					.map((regra) => {
						return { regra: regra.value, prioridade: regra.prioridade }
					}),
			}
		},
		criarObjetoQueRepresentaOsPlanejamentosDoCronograma() {
			return {
				cronogramaDeOrdemDeServicoId: this.cronogramaId,
				planejamentos: this.mapearPlanejamentos(),
			}
		},
		mapearPlanejamentos() {
			return this.estratos.map((estrato) => {
				return {
					planejamentoId: estrato.planejamentoId,
					inicioOs: new Date(estrato.inicioOs),
					prazoOs: new Date(estrato.prazoOs),
					dataReferencia: estrato.dataReferencia,
					estratoFlorestal: estrato.estrato,
					quantidadeDeParcelas: estrato.quantidadeDeParcelas,
					planoDeColheita: estrato.planoDeColheita,
					tipoDeOrdemDeServico: estrato.tipoDeOrdemDeServicoPlanejada,
					estratoFlorestalId: estrato.estratoFlorestalId,
					idsDosPlantios: estrato.plantiosDoGrupo.map((plantio) => plantio.properties.plantioId),
					executorId: estrato.executorId,
				}
			})
		},
		setarNovaVisualizacao(plantioClicado) {
			this.estratos.forEach((estrato) => {
				estrato.estaEmVisualizacao = false
				const plantioEstaNoEstrato = estrato.plantiosDoGrupo
					.map((plantio) => plantio.properties.plantioId)
					.some((plantioId) => plantioId === plantioClicado.properties.plantioId)
				if (plantioEstaNoEstrato) {
					estrato.estaEmVisualizacao = true
				}
			})

			this.forcarNovoEstratoEmVisualizacao++

			if (
				this.possuiRegraDeAgrupamento &&
				!this.plantioEstaNoGrupoQueEstaVisivel(plantioClicado.properties)
			)
				this.aplicarRegraDeAgrupamento()
		},
		plantioEstaNoGrupoQueEstaVisivel(plantioClicado) {
			return this.plantiosAgrupadosEmVisualizacao.plantiosDoGrupo.some(
				(plantio) => plantio.properties.plantioId === plantioClicado.plantioId,
			)
		},
		abrirFormularioParaEdicaoDePlanejamento() {
			var estratoParaEditar = this.estratoEmVisualizacao

			const fusoHorario3HorasEmMilisegundos = 10800000

			this.planejamentoDeEstratoEmEdicao.estratoFlorestalId = estratoParaEditar.estratoFlorestalId
			this.planejamentoDeEstratoEmEdicao.executorId = estratoParaEditar.executorId
			this.planejamentoDeEstratoEmEdicao.inicioOs = new Date(
				estratoParaEditar.inicioOs + fusoHorario3HorasEmMilisegundos,
			).toISOString()
			this.planejamentoDeEstratoEmEdicao.prazoOs = new Date(
				estratoParaEditar.prazoOs + fusoHorario3HorasEmMilisegundos,
			).toISOString()

			this.editarPlanejamento = true
		},
		fecharEdicaoDePlanejamento() {
			this.limparFormularioDeEdicaoDePlanejamento()
			this.editarPlanejamento = false
		},
		limparFormularioDeEdicaoDePlanejamento() {
			this.planejamentoDeEstratoEmEdicao.estratoFlorestalId = ''
			this.planejamentoDeEstratoEmEdicao.executorId = ''
			this.planejamentoDeEstratoEmEdicao.inicioOs = ''
			this.planejamentoDeEstratoEmEdicao.prazoOs = ''
		},
		confirmarEdicao() {
			const estrato = this.buscarEstratoQueEstaEmVisualizacao()

			if (estrato.executorId !== this.planejamentoDeEstratoEmEdicao.executorId) {
				this.descontarQuantidadeDeParcelasDoExecutor(estrato)
				this.acrescenterQuantidadeDeParcelasDoExecutor(estrato)
				this.atualizarExecutorDaOrdemDeServico(estrato)
			}

			const inicioOS = new Date(this.planejamentoDeEstratoEmEdicao.inicioOs).getTime()
			if (estrato.inicioOs !== inicioOS) estrato.inicioOs = inicioOS

			const prazoOS = new Date(this.planejamentoDeEstratoEmEdicao.prazoOs).getTime()
			if (estrato.prazoOs !== prazoOS) estrato.prazoOs = prazoOS

			this.fecharEdicaoDePlanejamento()
			this.$refs.ref__planejamento.forcarAtualizacaoDoGrafico()
		},
		buscarEstratoQueEstaEmVisualizacao() {
			return this.estratos.find(
				(estrato) => estrato.estratoFlorestalId === this.estratoEmVisualizacao.estratoFlorestalId,
			)
		},
		descontarQuantidadeDeParcelasDoExecutor(estrato) {
			const executor = this.executores.find(
				(executor) => executor.executorId === estrato.executorId,
			)
			if (executor && executor.quantidadeDeParcelasJaAlocadas > 0) {
				executor.quantidadeDeParcelasJaAlocadas =
					executor.quantidadeDeParcelasJaAlocadas > estrato.quantidadeDeParcelas
						? executor.quantidadeDeParcelasJaAlocadas - estrato.quantidadeDeParcelas
						: 0
			}
		},
		acrescenterQuantidadeDeParcelasDoExecutor(estrato) {
			const executor = this.executores.find(
				(executor) => executor.executorId === this.planejamentoDeEstratoEmEdicao.executorId,
			)
			if (executor) {
				executor.quantidadeDeParcelasJaAlocadas += estrato.quantidadeDeParcelas
			}
		},
		atualizarExecutorDaOrdemDeServico(estrato) {
			const executor = this.executores.find(
				(executor) => executor.executorId === this.planejamentoDeEstratoEmEdicao.executorId,
			)
			if (executor == undefined) {
				const executorId = this.planejamentoDeEstratoEmEdicao.executorId

				this.executores.push({
					executorId: executorId,
					parcelasPorDia: 0,
					quantidadeDeParcelasJaAlocadas: 0,
					datasEmServico: [],
					planejamentosDoExecutor: [],
				})

				estrato.executorId = executorId
			} else {
				estrato.executorId = executor.executorId
			}
		},
		setarEstratosVindosDoServidor(estratos) {
			estratos.forEach((estrato) => {
				estrato.plantiosDoGrupo = estrato.plantiosDoGrupo.features
				estrato.idsDeParcelasDoEstrato = estrato.plantiosDoGrupo
					.map((plantio) => plantio.properties.parcelas)
					.flat()
				estrato.quantidadeDeParcelas = estrato.idsDeParcelasDoEstrato.length
				this.estratos.push(estrato)
			})
		},
		setarPlantiosVindosDoServidor() {
			this.estratos.forEach((estrato) => {
				this.plantios.push(...estrato.plantiosDoGrupo)
			})
		},
		setarPlanejamentosDoExecutor() {
			this.executores.forEach((executor) => {
				var estratosDoExecutor = this.estratos.filter(
					(estrato) => estrato.executorId === executor.executorId,
				)

				estratosDoExecutor.forEach((estrato) => {
					const dataInicioDaOs = new Date(estrato.inicioOs)
					const dataPrazoDaOs = new Date(estrato.prazoOS)

					executor.quantidadeDeParcelasJaAlocadas += estrato.quantidadeDeParcelas
					executor.datasEmServico.push(dataInicioDaOs, dataPrazoDaOs)
					executor.planejamentosDoExecutor.push({
						planejamentoId: estrato.planejamentoId,
						inicioDaOS: estrato.inicioOs,
						prazoOS: estrato.prazoOs,
						quantidadeDeParcelas: estrato.quantidadeDeParcelas,
					})
				})
			})
		},
		async criarOrdensDeServico() {
			this.salvandoOrdensDeServico = true

			if (this.possuiEstratosPlanejados) {
				await this.atualizarFiltrosQueForamRealizados()
				await this.atualizarPlanejamentos()

				var planejamentos = this.mapearParaCriarOrdensDeServico()
				cadastrarOrdensDeServico(this.cronogramaId, planejamentos)
					.then(() => {
						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageText: this.$t('osCriadasEAtualizadas'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
						this.voltarParaCronogramas()
						this.salvandoOrdensDeServico = false
					})
					.catch(() => {
						this.salvandoOrdensDeServico = false
					})
			} else {
				const confirmaExclusaoDeCronograma = confirm(
					`Não existe nenhum planejamento, deseja excluir o registro de cronograma?`,
				)
				if (confirmaExclusaoDeCronograma) {
					excluirCronograma(this.cronogramaId)
						.then(() => {
							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageText: this.$t('cronogramaExcluido'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.voltarParaCronogramas()
							this.salvandoOrdensDeServico = false
							this.$emit('excluiuCronogramaDeOrdemDeServico', this.cronogramaId)
						})
						.catch(() => {
							this.salvandoOrdensDeServico = false
						})
				}
			}
		},
		mapearParaCriarOrdensDeServico() {
			return {
				planejamentos: this.estratos.map((estrato) => {
					return {
						fazendaId: estrato.plantiosDoGrupo[0].properties.fazendaId,
						executorId: estrato.executorId,
						planejamentoId: estrato.planejamentoId,
						inicioOs: new Date(estrato.inicioOs),
						prazoOs: new Date(estrato.prazoOs),
						estratoFlorestal: estrato.estrato,
						quantidadeDeParcelas: estrato.quantidadeDeParcelas,
						planoDeColheita: estrato.planoDeColheita,
						tipoDeOrdemDeServico: estrato.tipoDeOrdemDeServicoPlanejada,
						estratoFlorestalId: estrato.estratoFlorestalId,
						idsDosPlantios: estrato.plantiosDoGrupo.map((plantio) => plantio.properties.plantioId),
						idsParcelas: estrato.idsDeParcelasDoEstrato,
					}
				}),
			}
		},
	},
	/** Mixin separado para conseguir calcular as datas para o planejamento de ordem de servico */
	mixins: [otimizacaoDeCronogramaDeOrdemDeServicoMixins],
	created() {
		recuperarOcorrenciasParaCronogramaDeOrdemDeServico().then((response) => {
			this.ocorrencias = response.data
		})

		getDropdownExecutores().then((response) => {
			this.todosOsExecutores = response

			if (this.cronogramaId) {
				this.carregandoPlantios = true

				buscarPlanejamentosParaGantt(this.cronogramaId).then((response) => {
					let estratos = response.data

					this.setarEstratosVindosDoServidor(estratos)
					this.setarPlantiosVindosDoServidor()
					this.setarPlanejamentosDoExecutor()

					if (this.estratos.length > 0) {
						this.estratos[0].estaEmVisualizacao = true
						this.setarZoomDoMapa(this.estratos[0].plantiosDoGrupo)
						this.plotarTabelaDePlanejamento()
					}

					this.carregandoPlantios = false
				})
			}
		})
	},
	mounted() {
		if (this.dataDeInicio && this.dataDeFinalizacao) {
			this.$refs.ref__planejamento.dataDeInicio = new Date(this.dataDeInicio)
			this.$refs.ref__planejamento.dataDeFinalizacao = new Date(this.dataDeFinalizacao)
		}
	},
	props: {
		dataDeInicio: {
			type: String,
			required: true,
		},
		dataDeFinalizacao: {
			type: String,
			required: true,
		},
		cronogramaId: {
			type: String,
			required: true,
		},
		planosDeColheita: {
			type: Array,
		},
		planejamentoJaGerouOrdensDeServico: {
			type: Boolean,
			required: true,
		},
		regrasDeOtimizacao: Object,
		filtrosSalvos: Object,
	},
}
</script>

<style scoped>
.container__planejamentocronograma {
	width: 100%;
	height: 100%;
	background-color: white;
	display: flex;
	flex-direction: column;
}

.container__planejamentocronograma__planejamento {
	height: 50%;
}

.container__planejamentocronograma__planejamento.extend {
	height: 100%;
}

.container__planejamentocronograma__mapa {
	height: 50%;
}

.container__planejamentocronograma__mapa.extend {
	height: 0;
}

.container__planejamentocronograma__mapa__filtros {
	background-color: rgba(255, 255, 255, 0.3);
	border-radius: 5px;
	width: 100%;
	position: relative;
	width: 100%;
	display: flex;
	padding: 1rem;
}

.container__planejamentocronograma__mapa__agrupamento {
	position: relative;
	display: flex;
	width: 100%;
	padding-top: 0.5rem;
}

.container__planejamentocronograma__mapa__filtros__escolhidos {
	display: flex;
	flex-wrap: wrap;
	flex: 1;
}

.container__planejamentocronograma__mapa__filtros__buttons {
	display: flex;
	justify-items: center;
	align-items: flex-start;
}

.container__planejamentocronograma__mapa__filtros__buttons button {
	margin-left: 0.5rem;
	background-color: white;
	color: rgb(var(--color-primary));
	padding: 0 0.5rem;
	border: solid 1px rgb(var(--color-primary));
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
}

.container__planejamentocronograma__mapa__filtros__buttons i {
	margin: 0 0.5rem;
	background-color: white;
	color: rgb(var(--color-primary));
	border: 1px solid rgb(var(--color-primary));
	padding: 0 0.5rem;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
}

.container__planejamentocronograma__mapa__loading {
	position: absolute;
	height: 100%;
	width: 100%;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 1000;
	color: white;
	cursor: default;
	font-size: 0.875rem;
	display: flex;
	align-items: center;
	flex-direction: column;
}

.container__planejamentocronograma__foto__ocorrencia {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: rgba(0, 0, 0, 0.8);
}

.container__planejamentocronograma__foto__ocorrencia__inner {
	position: relative;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: inline-block;
}

.container__planejamentocronograma__foto__ocorrencia__inner__imagem {
	max-height: 80vh;
	object-fit: contain;
}

.container__planejamentocronograma__foto__ocorrencia__inner_detalhes {
	position: absolute;
	width: 100%;
	padding: 1rem;
	background-color: rgba(0, 0, 0, 0.7);
	color: white;
	bottom: 0;
}

.container__planejamentocronograma__foto__ocorrencia__inner_detalhes p {
	margin: 0;
}

.container__planejamentocronograma__foto__ocorrencia__inner_detalhes > p {
	font-size: 1rem;
	font-weight: 700;
}

.container__planejamentocronograma__foto__ocorrencia__inner_detalhes p:last-child {
	font-size: 0.875rem;
	font-weight: 100;
}

.container__planejamentocronograma__edicao {
	padding: 1.5rem 2rem;
	display: flex;
	background-color: white;
	font-size: 0.875rem;
	user-select: none;
	font-size: 0.75rem;
	flex-direction: column;
}

.container__planejamentocronograma__header {
	display: flex;
	flex-direction: column;
}

.container__planejamentocronograma__header__titulo {
	font-size: 1.5rem;
	font-weight: 700;
	line-height: normal;
	display: flex;
	-ms-flex-align: start;
	color: rgb(var(--color-primary));
	align-items: center;
}

.container__planejamentocronograma__header__titulo i {
	font-size: 1.2rem;
	margin-right: 0.5rem;
}

.container__planejamentocronograma__header__titulo p {
	margin: 0;
}

.container__planejamentocronograma__subtitulo {
	color: var(--color-gray-dark);
	font-weight: 400;
}

.container__planejamentocronograma__body {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
}

.container__planejamentocronograma__bottom {
	display: flex;
	margin-top: 1rem;
}

@media screen and (min-width: 992px) {
	.container__planejamentocronograma {
		flex-direction: row;
	}

	.container__planejamentocronograma__planejamento {
		height: 100%;
		width: 60%;
	}

	.container__planejamentocronograma__planejamento.extend {
		width: 100%;
	}

	.container__planejamentocronograma__mapa {
		height: 100%;
		width: 40%;
	}

	.container__planejamentocronograma__mapa.extend {
		width: 0;
	}
}
</style>
